import { useNavigate } from "react-router-dom";
import styles from "./NotFound.module.css";

const NotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };
  return (
    <article className={styles.content}>
      <div className={styles.notFoundImg}>
        <img src={"/assets/image/404.png"} />
      </div>
      <h1 className={styles.headerWrapper}>صفحه مورد نظر شما یافت نشد.</h1>
      <p>
        <button onClick={goHome}>بازگشت به صفحه اصلی</button>
      </p>
    </article>
  );
};

export default NotFound;
